import { render } from "./GameOver.vue?vue&type=template&id=7f191cfe&scoped=true"
import script from "./GameOver.vue?vue&type=script&lang=js"
export * from "./GameOver.vue?vue&type=script&lang=js"

import "./GameOver.vue?vue&type=style&index=0&id=7f191cfe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f191cfe"]])

export default __exports__